export default {
  styleOverrides: {
    root: {
      backgroundColor: 'white'
    }
  }
}
